module.exports = __webpack_public_path__ + "static/img/role2.1d1d39d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/appframe/img/role/role2.png
// module id = Sb4O
// module chunks = 11